import { api, ApiError } from "../api.ts";
import { h, setMsg } from "../dom.ts";
import { t } from "../i18n/index.ts";
import { brandLockup, BRAND_NAME } from "../ui/brand.ts";

/** Forgot-password: enter a username/email, we email a reset link. The response
 *  is deliberately the same whether or not the account exists (no probing). */
export function forgotScreen(): HTMLElement {
  const el = h(`
    <main class="card">
      <h1 class="brand" aria-label="${BRAND_NAME}">${brandLockup}</h1>
      <p class="tagline">${t("forgot.tagline")}</p>
      <form novalidate>
        <label class="field">
          <span>${t("forgot.label")}</span>
          <input name="login" autocomplete="username" autofocus required />
        </label>
        <button class="btn primary" type="submit">${t("forgot.submit")}</button>
        <p class="msg" role="status" aria-live="polite"></p>
      </form>
      <p class="fine"><a data-link href="/login">${t("forgot.back")}</a></p>
    </main>
  `);

  const form = el.querySelector("form")!;
  const msg = el.querySelector(".msg") as HTMLElement;
  const button = el.querySelector("button") as HTMLButtonElement;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const login = String(new FormData(form).get("login") ?? "").trim();
    if (!login) {
      setMsg(msg, t("forgot.need"), "bad");
      return;
    }
    button.disabled = true;
    setMsg(msg, t("forgot.sending"));
    try {
      await api.forgotPassword(login);
      // Success copy never confirms the account exists.
      form.querySelector(".field")!.remove();
      button.remove();
      setMsg(msg, t("forgot.sent"), "ok");
    } catch (err) {
      setMsg(msg, err instanceof ApiError ? err.message : t("forgot.failed"), "bad");
      button.disabled = false;
    }
  });

  return el;
}
